<template>
  <div class="col-sm-12">
                <div class="card">
                  <div class="card-header pb-0">
                    <h5>Kick start your project development !</h5>
                  </div>
                  <div class="card-body">
                    <p>Getting start with your project custom requirements using a ready template which is quite difficult and time taking process, Zeta Admin provides useful features to kick start your project development with no efforts !</p>
                    <ul>
                      <li>
                        <p>Zeta Admin provides you getting start pages with different layouts, use the layout as per your custom requirements and just change the branding, menu & content.</p>
                      </li>
                      <li>
                        <p>Every components in Zeta Admin are decoupled, it means use only components you actually need! Remove unnecessary and extra code easily just by excluding the path to specific SCSS, JS file.</p>
                      </li>
                      <li>
                        <p>It use PUG as template engine to generate pages and whole template quickly using node js. Save your time for doing the common changes for each page (i.e menu, branding and footer) by generating template with pug.</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
               <div class="col-sm-12">
                <div class="card">
                  <div class="card-header pb-0">
                    <h5>What is starter kit ?</h5>
                  </div>
                  <div class="card-body">
                    <p>Starter kit is a set of pages with different layouts, useful for your next project to start development process from scratch with no time.</p>
                    <ul>
                      <li>
                        <p>Each layout includes basic components only.</p>
                      </li>
                      <li>
                        <p>Select your choice of layout from starter kit, customize it with optional changes like colors and branding, add required dependency only.</p>
                      </li>
                      <li>
                        <p>Using template engine to generate whole template quickly with your selected layout and other custom changes. </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
               <div class="col-sm-12">
                <div class="card">
                  <div class="card-header pb-0">
                    <h5>How to use starter kit ?</h5>
                  </div>
                  <div class="card-body">
                    <p><span class="f-w-600">HTML</span></p>
                    <p>If you know just HTML, select your choice of layout from starter kit folder, customize it with optional changes like colors and branding, add required dependency only.</p>
                    <p><span class="f-w-600">PUG</span></p>
                    <p>To use PUG it required node.js and basic knowledge of using it. Using PUG as template engine to generate whole template quickly with your selected layout and other custom changes. To getting start with PUG usage & template generating process please refer template documentation.</p>
                    <div class="alert alert-primary inverse" role="alert"><i class="icon-info-alt"></i>
                      <h5>Tips!</h5>
                      <p>Hideable navbar option is available for fixed navbar with static navigation only. Works in top and bottom positions, single and multiple navbars.</p>
                    </div>
                  </div>
                </div>
              </div>
</template>
